import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const InternPlanFormBlueprint = [
  /* 一、基本資料 */
  {
    type: 'section_title',
    text: '一、基本資料',
  },
  {
    key: 'department_id',
    type: 'select',
    div: 3,
    disabled: true,
    label: '就讀系/所：',
  },
  {
    key: 'student_account',
    type: 'input',
    div: 3,
    disabled: true,
    required: true,
    label: '學號：',
    max_length: 500,
  },
  {
    key: 'student_name',
    type: 'input',
    div: 3,
    disabled: true,
    required: true,
    label: '姓名：',
    max_length: 500,
  },
  {
    key: 'internship',
    type: 'input',
    div: 2,
    disabled: true,
    required: true,
    label: '實習單位：',
    max_length: 500,
  },
  {
    key: 'intern_start_time',
    type: 'output_button',
    custom_type: 'date',
    div: 4,
    label: '實習期間：',
    placeholder: '開始時間',
    icon: 'date',
    check: (cur_val) => {
      if(!cur_val) return '必填';
    },
  },
  {
    key: 'intern_end_time',
    type: 'output_button',
    custom_type: 'date',
    class_name: 'align_self_end',
    div: 4,
    placeholder: '結束時間',
    icon: 'date',
    check: (cur_val) => {
      if(!cur_val) return '必填';
    },
  },
  {
    key: 'school_teacher',
    type: 'input',
    div: 2,
    required: true,
    label: '學校輔導教師：',
    max_length: 500,
  },
  {
    key: 'intern_teacher',
    type: 'input',
    div: 2,
    required: true,
    label: '實習單位輔導教師：',
    max_length: 500,
  },
  { type: 'hr' },
  /* 二、實習學習內容 */
  {
    type: 'section_title',
    text: '二、實習學習內容',
  },
  /* 實習課程目標 */
  {
    type: 'section_title',
    class_name: 'small_section',
    text: '實習課程目標',
    sub_text: '(依系科課程發展結果及系科專業領域性質，撰寫開設實習課程之目標，可自行增加)',
  },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        key: 'intern_target',
        type: 'radio',
        options: ['一般機械工程師', '精密機械工程師', '生產管理師', '機電控制工程師', '電子技術工程師', '資通訊系統工程師', '積體電路設計與應用工程師', '智慧型控制工程師', '電力與電能轉換工程師', '軟體研發系統工程師', '資訊工程師', '系統分析師', '程式設計師', '化學工程師', '材料製程工程師', '應用化學工程師', '環境工程師', '工業安全衛生工程師', '工業工程師', '品質管理工程師', '生產技術製程工程師', '行政管理師', '行銷/業務/企劃國貿人員', '會計/財金人員', '行政人員', '人力資源/人事人員', '外語教學老師', '英文秘書', '產品銷售業務人員', '平面設計師', '3D設計師', '繪圖及網頁製作人員', '多媒體設計製作人員', '品牌視覺設計師', '展場設計師', '設計企劃管理人員', '藝術行政人員', '建築設計師', '室內設計師', '建築繪圖人員', '營建工地工程師', '測量/設計/監造/監測工程師', '營建工程管理工程師', '營建監造工程師', '土木營造-品管人員', '營造品管人員', '專利工程師', '專利程序人員'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48],
      },
      {
        type: 'input_onoff',
        input_key: 'intern_target_other',
        checked_required: true,
        max_length: 500,
        label: '其他',
      },
    ],
  },
  /* 實習課程內容規劃 */
  {
    type: 'section_title',
    class_name: 'small_section',
    text: '實習課程內容規劃',
  },
  {
    type: 'outer',
    key: 'intern_content_plan',
    blocks: [],
  },
  /* 實習資源投入及輔導 */
  {
    type: 'section_title',
    class_name: 'small_section',
    text: '實習資源投入及輔導',
  },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        type: 'span',
        class_name: 'outer_title',
        text: '1.實習單位提供實習指導與資源說明',
      },
      {
        key: 'basic_train',
        type: 'checkbox',
        class_name: 'list_label',
        css_var: { 'custom_label': '"◎實務基礎訓練"' },
        min: 1,
        label: '實習單位提供實習學生的整體培訓規劃（可複選）',
        options: ['企業文化訓練', '企業知識訓練', '工業安全訓練'],
        values: [1, 2, 3],
      },
      {
        input_key: 'basic_train_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
      {
        key: 'main_train',
        type: 'checkbox',
        class_name: 'list_label',
        css_var: { 'custom_label': '"◎實務主題訓練"' },
        min: 1,
        options: ['產品知識探討', '產品技術問題釐清', '知識管理', '學習內容溝通', '實務技術問題排除', '產品除錯', '實務技術支援', '實務案例分享', '實務問題分析', '製程改善', '庶務管理', '技術指導'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
      {
        input_key: 'main_train_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
      {
        key: 'resources_invested',
        type: 'checkbox',
        min: 1,
        label: '實習機構提供資源與設備投入情形（可複選）',
        options: ['實驗設備', '儀器機台', '實驗程序', '教育培訓', '資訊設備', '測試耗材', '車輛裝備', '服裝配件'],
        values: [1, 2, 3, 4, 5, 6, 7, 8],
      },
      {
        input_key: 'resources_invested_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
    ],
  },
  { type: 'hr', class_name: 'gray_hr' },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        type: 'span',
        class_name: 'outer_title',
        text: '2.實習單位輔導教師進行實習輔導形式及規劃',
      },
      {
        key: 'guide_content',
        type: 'checkbox',
        min: 1,
        label: '實習單位輔導教師提供的指導內容（可複選）',
        options: ['程式設計', '機台操作', '實驗程序', '機械模具', '文件撰寫', '檢測操作', '實驗測試', '材料鍍膜', '除錯操作', '資訊管理', '採購備料', '製程管理', '設計溝通', '藝術創作', '財經規劃', '創新管理', '設計模擬', '軟體操作', '經營管理'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      },
      {
        input_key: 'guide_content_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
      {
        key: 'counseling',
        type: 'checkbox',
        min: 1,
        label: '實習單位輔導教師提供的輔導方式（可複選）',
        options: ['口述解說', '操作示範', '案例研討'],
        values: [1, 2, 3],
      },
      {
        input_key: 'counseling_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
    ],
  },
  { type: 'hr', class_name: 'gray_hr' },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        type: 'span',
        class_name: 'outer_title',
        text: '3.學校輔導教師進行輔導及訪視之具體規劃',
      },
      {
        key: 'counseling_content',
        type: 'checkbox',
        min: 1,
        label: '學校輔導教師提供輔導內容（可複選）',
        options: ['產業趨勢', '專業知識指導', '實驗指導', '人際溝通', '學習表現', '不適應輔導'],
        values: [1, 2, 3, 4, 5, 6],
      },
      {
        input_key: 'counseling_content_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
      {
        key: 'visit',
        type: 'checkbox',
        min: 1,
        label: '學校輔導教師訪視作業（可複選）',
        options: ['實習前輔導', '實地訪視', '實習異常輔導訪視', '電話聯繫', '視訊聯繫', '社群網路軟體', '電子郵件聯繫'],
        values: [1, 2, 3, 4, 5, 6, 7],
      },
      {
        input_key: 'visit_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
    ],
  },
  { type: 'hr' },
  /* 三、實習成效考核與回饋 */
  {
    type: 'section_title',
    text: '三、實習成效考核與回饋',
  },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        type: 'span',
        class_name: 'outer_title',
        text: '1.實習成效考核指標',
      },
      {
        key: 'intern_assess',
        type: 'checkbox',
        min: 1,
        label: '實習單位輔導教師評核（可複選）',
        options: ['敬業精神', '品質效率', '學習熱忱', '團隊合群、職業倫理'],
        values: [1, 2, 3, 4],
      },
      {
        input_key: 'intern_assess_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
      {
        key: 'school_assess',
        type: 'checkbox',
        min: 1,
        label: '學校輔導教師評核（可複選）',
        options: ['報告結構內容', '報告與實務工作關聯性', '繳報告準時性', '學習成果'],
        values: [1, 2, 3, 4],
      },
      {
        input_key: 'school_assess_other',
        type: 'input_onoff',
        checked_required: true,
        max_length: 500,
        label: '其他：',
      },
    ],
  },
  { type: 'hr', class_name: 'gray_hr' },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        type: 'span',
        class_name: 'outer_title',
        text: '2.實習成效與教學評核方式',
      },
      {
        key: 'check_assess',
        type: 'radio',
        label: '學生實習成果的評核期程',
        options: ['實習中', '實習結束'],
        values: [1, 2],
      },
      {
        key: 'check_teacher',
        type: 'radio',
        label: '評核人員',
        options: ['實習單位輔導教師(評核50%)', '學校輔導教師(評核50%)'],
        values: [1, 2],
      },
    ],
  },
  { type: 'hr', class_name: 'gray_hr' },
  {
    type: 'outer',
    class_name: 'checkbox_block',
    blocks: [
      {
        type: 'span',
        class_name: 'outer_title',
        text: '3.實習回饋方式及規劃（可複選）',
      },
      {
        key: 'intern_feedback',
        type: 'checkbox',
        min: 1,
        options: ['實習成效檢討會議', '實習課程檢討會議', '實習問卷調查', '實習成果競賽', '輔導經驗交流', '學生心得分享', '實習職缺篩選檢討', '實習機構合作檢討', '實習轉換單位檢討', '衍生產業實務專題', '教師實務深耕', '教師實務研習', '業界產學合作', '專業課程諮詢調整', '校務研究分析', '校務研究追蹤'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      },
    ],
  },
];